Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
var clsx = require('clsx');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var useStyles = core.makeStyles(function (theme) {
  var _a;
  return {
    root: (_a = {
      padding: theme.spacing(3, 2)
    }, _a[theme.breakpoints.up("md")] = {
      padding: theme.spacing(4, 4)
    }, _a[theme.breakpoints.up("lg")] = {
      padding: theme.spacing(5, 8)
    }, _a),
    noTopSpacing: {
      paddingTop: 0
    },
    noRightSpacing: {
      paddingRight: 0
    },
    noBottomSpacing: {
      paddingBottom: 0
    },
    noLeftSpacing: {
      paddingLeft: 0
    }
  };
});
var Content = function Content(_a) {
  var _b = _a.noTopSpacing,
    noTopSpacing = _b === void 0 ? false : _b,
    _c = _a.noRightSpacing,
    noRightSpacing = _c === void 0 ? false : _c,
    _d = _a.noBottomSpacing,
    noBottomSpacing = _d === void 0 ? false : _d,
    _e = _a.noLeftSpacing,
    noLeftSpacing = _e === void 0 ? false : _e,
    children = _a.children;
  var classes = useStyles();
  return React__default['default'].createElement(core.Box, {
    className: clsx__default['default'](classes.root, noTopSpacing && classes.noTopSpacing, noRightSpacing && classes.noRightSpacing, noBottomSpacing && classes.noBottomSpacing, noLeftSpacing && classes.noLeftSpacing)
  }, children);
};
exports.default = Content;